import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const StyledContainer = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.white};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  padding: ${({ theme: { sizing } }) =>
    `${sizing.fds_size_40} ${sizing.fds_size_56}  ${sizing.fds_size_40}`};
  width: 526px;
  height: fit-content;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
    padding: ${({ theme: { reference } }) => `${reference.dimension_32} ${reference.dimension_16}`};
  }
`;
